<ng-container *transloco="let t">
  <nav class="mt-lg hidden sm:block">
    <h3 class="plot-sm">{{ t('article.tableOfContent.title') }}</h3>
    <ol class="mt-sm flex flex-row flex-wrap gap-xs">
      @for (item of tableOfContent; track item.id) {
        <li (click)="tocElementClicked(item.id)">
          <a class="btn btn-link" role="button">{{ item.title }}</a>
        </li>
        @if (!$last) {
          <ng-container *ngTemplateOutlet="verticalSeparator" />
        }
      }
    </ol>
  </nav>
  <nav class="sticky top-[var(--navbar-height-mobile)] z-10 mt-lg block bg-white sm:hidden">
    <div class="flex flex-row flex-nowrap items-baseline py-sm">
      <label for="toc" class="mr-xs grow-0">{{ t('article.tableOfContent.selector') }}</label>
      <select id="toc" class="grow font-semibold" (change)="tocSelectorChanged($event)">
        <option disabled [defaultSelected]="true">{{ t('article.tableOfContent.selectorHint') }}</option>
        @for (item of tableOfContent; track item.id; let i = $index) {
          <option [value]="item.id" [selected]="i === currentItemIndex">{{ item.title }}</option>
        }
      </select>
    </div>
    <ng-container
      [ngTemplateOutlet]="horizontalSeparator"
      [ngTemplateOutletContext]="{items: tableOfContent, active: currentItemIndex}"
    />
  </nav>
</ng-container>

<ng-template #verticalSeparator>
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="32" viewBox="0 0 2 32" fill="none">
    <path d="M1 1L0.999999 31" stroke-linecap="round" class="stroke-grey-300" />
  </svg>
</ng-template>

<ng-template #horizontalSeparator let-items="items" let-active="active">
  <div class="flex h-[2px] w-full rounded-3xl" #bar>
    @for (item of items; track item; let index = $index) {
      <div
        class="h-full"
        [class.bg-grey-300]="index > active"
        [class.bg-primary]="index <= active"
        [style.width.px]="bar.offsetWidth / items.length"
      ></div>
    }
  </div>
</ng-template>
